import { Random } from '../../java/util/Random';
import { KursblockungDynDaten } from '../../core/kursblockung/KursblockungDynDaten';
import { KursblockungAlgorithmusK, cast_de_svws_nrw_core_kursblockung_KursblockungAlgorithmusK } from '../../core/kursblockung/KursblockungAlgorithmusK';
import { Class } from '../../java/lang/Class';
import { Logger } from '../../core/logger/Logger';
import { System } from '../../java/lang/System';

export class KursblockungAlgorithmusKSchnellW extends KursblockungAlgorithmusK {


	/**
	 * Im Konstruktor kann die Klasse die jeweiligen Datenstrukturen aufbauen. Kurse dürfen in diese Methode noch nicht
	 * auf Schienen verteilt werden.
	 *
	 * @param random     Ein {@link Random}-Objekt zur Steuerung des Zufalls über einen Anfangs-Seed.
	 * @param logger     Logger für Benutzerhinweise, Warnungen und Fehler.
	 * @param dynDaten   Die dynamischen Blockungsdaten.
	 */
	public constructor(random: Random, logger: Logger, dynDaten: KursblockungDynDaten) {
		super(random, logger, dynDaten);
	}

	public toString(): string {
		return "SchnellW";
	}

	public berechne(pEndzeit: number): void {
		if (this.dynDaten.gibKurseDieFreiSindAnzahl() === 0) {
			return;
		}
		this.dynDaten.aktionSchuelerAusAllenKursenEntfernen();
		this.dynDaten.aktionKurseFreieZufaelligVerteilen();
		this.dynDaten.aktionSchuelerVerteilenMitGewichtetenBipartitemMatching();
		this.dynDaten.aktionZustandSpeichernK();
		do {
			this.veraendereDieKurslageZufaelligEinWenig();
		} while (System.currentTimeMillis() < pEndzeit);
	}

	/**
	 * Kurslage wird ein wenig zufällig verändert und bewertet.
	 * Falls sich die Bewertung verschlechtert, wird die Veränderung rückgängig gemacht.
	 */
	private veraendereDieKurslageZufaelligEinWenig(): void {
		do {
			this.dynDaten.aktionSchuelerAusAllenKursenEntfernen();
			this.dynDaten.aktionKursVerteilenEinenZufaelligenFreien();
			this.dynDaten.aktionSchuelerVerteilenMitGewichtetenBipartitemMatching();
			if (this.dynDaten.gibCompareZustandK1NW2KD3FW() > 0) {
				this.dynDaten.aktionZustandSpeichernK();
				return;
			}
		} while (this.rnd.nextBoolean());
		this.dynDaten.aktionZustandLadenK();
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.kursblockung.KursblockungAlgorithmusKSchnellW';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.kursblockung.KursblockungAlgorithmusKSchnellW', 'de.svws_nrw.core.kursblockung.KursblockungAlgorithmusK'].includes(name);
	}

	public static readonly class = new Class<KursblockungAlgorithmusKSchnellW>('de.svws_nrw.core.kursblockung.KursblockungAlgorithmusKSchnellW');

}

export function cast_de_svws_nrw_core_kursblockung_KursblockungAlgorithmusKSchnellW(obj: unknown): KursblockungAlgorithmusKSchnellW {
	return obj as KursblockungAlgorithmusKSchnellW;
}
